import { CircularProgress } from "@mui/material"
import { Box } from "@mui/system"
import React, { useContext, useEffect, useMemo } from "react"
import { useSearchParams } from "react-router-dom"
import { customPalette } from "../../../../../../../../../theme"
import { IconInbox } from "../../../../../../../../components/custom-icons/icon-inbox"
import { TabEnum } from "../../../../../../../../components/tabs/tabs"
import { pagesUrl } from "../../../../../../../../core/appConstants"
import { AppSideBarContext } from "../../../../../../../../core/context/AppSideBarContext/AppSideBarContext"
import { BSVariantContext } from "../../../../../../../../core/context/beem-shot/BSVariant/BSVariantContext"
import { AppNavBarContext, NavbarTypeEnum } from "../../../../../../../../core/context/nav-bar/AppNavBarContext"
import { CoverImgProjectContext } from "../../../../../../../../core/context/project/CoverImgProjectContext"
import { ProjectContext } from "../../../../../../../../core/context/project/ProjectContext"
import { resolveUrl } from "../../../../../../../../core/services/http-service"
import { BSBuildingContext } from "../../components/context/BSBuildingContext"
import { BSBimModelChoice } from "./components/BSBimModelChoicePage"
import { BSBuildingWithoutBimModel } from "./components/BSBuildingWithoutBimModel"

export function BSBuildingChoicePage(): React.JSX.Element {
  const [searchParams] = useSearchParams()

  const isForCreation = useMemo(() => {
    const fromParams = searchParams.get("from")
    return fromParams !== "TAB"
  }, [searchParams])

  const { setShowAppSide, setFullScreen } = useContext(AppSideBarContext)
  const { setTypeNavBar, setImageFile, setIcon, setTitle, setPreviousUrl, setStepHeader } = useContext(AppNavBarContext)
  const { file } = useContext(CoverImgProjectContext)
  const { project } = useContext(ProjectContext)
  const { selectedVariant } = useContext(BSVariantContext)
  const { selectedBSBuilding } = useContext(BSBuildingContext)

  useEffect(() => {
    setImageFile(file)
    setIcon(<IconInbox sx={{ color: customPalette.black, fontWeight: "2px" }} />)
    setTitle(selectedVariant?.name ?? "")
    if (isForCreation) {
      setTypeNavBar(NavbarTypeEnum.BUILDING_HEADER)

      setPreviousUrl(
        resolveUrl(pagesUrl.VARIANT_DETAILS, [project?.id, selectedVariant?.id], {
          bsBuildingId: selectedBSBuilding?.id,
          tab: TabEnum.BUILDING_MORPHOLOGY_OR_BIM,
        })
      )
    } else {
      setPreviousUrl(
        resolveUrl(pagesUrl.VARIANT_DETAILS, [project?.id, selectedVariant?.id], {
          bsBuildingId: selectedBSBuilding?.id,
          tab: TabEnum.BUILDING_MORPHOLOGY_OR_BIM,
        })
      )
      setTypeNavBar(NavbarTypeEnum.HEAD_WITHOUT_STEP)
    }
    setFullScreen(false)
    setStepHeader(1)
  }, [
    file,
    isForCreation,
    project?.id,
    searchParams,
    selectedBSBuilding?.id,
    selectedVariant?.id,
    selectedVariant?.name,
    setFullScreen,
    setIcon,
    setImageFile,
    setPreviousUrl,
    setStepHeader,
    setTitle,
    setTypeNavBar,
  ])

  useEffect(() => {
    setShowAppSide(false)
  }, [setShowAppSide])

  return (
    <Box
      sx={{
        mt: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}>
      {selectedBSBuilding === undefined && (
        <Box>
          <CircularProgress />
        </Box>
      )}
      {selectedBSBuilding !== undefined && selectedBSBuilding?.bim && <BSBimModelChoice isForCreation={isForCreation} />}

      {selectedBSBuilding !== undefined && !selectedBSBuilding?.bim && <BSBuildingWithoutBimModel />}
    </Box>
  )
}
